import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { retrieveEmojis } from 'features/emoji/asyncThunks'
import { useEmojiState } from 'hooks/useEmojiState'

const useRetrieveEmojis = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(retrieveEmojis())
  }, [dispatch])

  return useEmojiState()
}

export default useRetrieveEmojis
